module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud2-74f4d8a50d8ba5fd7a3bf6207f3322fc.svg";